import React from 'react';
import { connect } from 'react-redux';
import properties from '../../modules/ajio-util/properties';
import { createCookie, readCookie } from '../common/Cookie';
import { storageAvailable } from '../common/storageAvailable';
import { isServerRendering } from '../../utils/pageInfo';

class PopupRoadblock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpen: true,
      bodyDomRef: null
    };
  }

  setLocalStorageAndRemoveNoScroll() {
    let body = this.state.bodyDomRef
      ? this.state.bodyDomRef
      : document.getElementsByTagName('body')[0];
    body.classList.remove('noScroll');
    if (storageAvailable('localStorage')) {
      window.localStorage.setItem('roadblockclosed', true);
    }
  }

  setSessionCookie() {
    let body = this.state.bodyDomRef
      ? this.state.bodyDomRef
      : document.getElementsByTagName('body')[0];
    body.classList.remove('noScroll');
    if (window.sessionStorage) {
      window.sessionStorage.setItem('rb', true);
    }
  }

  togglepopup() {
    this.setState({ popupOpen: false });
    this.setSessionCookie();
  }

  hideRoadblock() {
    this.setLocalStorageAndRemoveNoScroll();
  }

  componentDidMount() {
    if (this.refs['popup-roadblock']) {
      let body = document.getElementsByTagName('body')[0];
      this.state.bodyDomRef = body;
      body.classList.add('noScroll');
    }
  }

  getDeepLinkUrl() {
    let pageType = window.pageType;
    let deepLinkUrl = '#';
    if (!isServerRendering()) {
      if (
        navigator.userAgent.toUpperCase().indexOf('IPAD') > -1 ||
        navigator.userAgent.toUpperCase().indexOf('IPHONE') > -1
      ) {
        deepLinkUrl = `https://itunes.apple.com/in/app/ajio-online-shopping-app/id1113425372?rutm_campaign=${pageType}&utm_source=App_Install_Popup&utm_medium=App_Install_Popup`;
      } else if (navigator.userAgent.toUpperCase().indexOf('ANDROID') > -1) {
        deepLinkUrl = `https://play.google.com/store/apps/details?id=com.ril.ajio&referrer=utm_source%3DApp_Install_Popup%26utm_medium%3DApp_Install_Popup%26utm_campaign%3D${pageType}`;
      } else {
        deepLinkUrl = '#';
      }
    }

    return deepLinkUrl;
  }

  // Donot show overlay if image load fails
  onImageLoadError = () => {
    this.setState({
      popupOpen: false
    });
  };

  render() {
    let {
      roadblockwcms: {
        returningUserImageUrl = '',
        newUserImageUrl = '',
        oneLinkUrl = '',
        visible = true
      } = {}
    } = this.props;
    let marketingObj = {};
    let marketingCookie = readCookie('cdigiMrkt') || '';
    let marketingCookieSplit = marketingCookie.split('|');

    for (let i = 0; i < marketingCookieSplit.length; i++) {
      let eachValueSplit = marketingCookieSplit[i].split(':');
      marketingObj[eachValueSplit[0]] = eachValueSplit[1];
    }

    let utmparams = `utm_campaign=MSITE_direct`;
    if (marketingObj && marketingObj.utm_campaign) {
      let campaign_value = marketingObj.utm_campaign;
      utmparams = `utm_campaign=MSITE_${campaign_value}`;
    }

    // let __utmz;
    // let utmparams = '';
    // const roadBlock = properties.getProperty("roadBlock");
    // createCookie('__utmz', '43838368.1523974267.1.1.utmcsr=(direct)|utmccn=(direct)|utmcmd=(none)', 730);
    // __utmz = readCookie('__utmz');

    // if(__utmz && __utmz !== '') {
    //   const srcarr = __utmz.split('.');
    //   const utmarr = srcarr.length > 0 ? (srcarr[srcarr.length -1].split('|')) : [];
    //   var regExp = /\(([^)]+)\)/;
    //   var matches = utmarr.length > 1 ? regExp.exec(utmarr[1].split("=")[1]) : [];
    //   let campaign_value = matches.length > 1 ? matches[1] : utmarr.length > 1 ? utmarr[1].split("=")[1] : 'direct';
    //     utmparams = `utm_campaign=MSITE_${campaign_value}`;
    // } else {
    //   utmparams = `utm_campaign=MSITE_direct`;
    // }
    var deepLinkUrl = 'javascript:void(0)';
    var link_af_dp;
    if (!isServerRendering()) {
      if (
        navigator.userAgent.toUpperCase().indexOf('ANDROID') > -1 ||
        navigator.userAgent.toUpperCase().indexOf('IPAD') > -1 ||
        navigator.userAgent.toUpperCase().indexOf('IPHONE') > -1
      ) {
        link_af_dp = `${properties.getProperty('siteUrl') + window.location.pathname}?${utmparams}`;
        link_af_dp = encodeURIComponent(link_af_dp);
        var deepLinkUrl = oneLinkUrl ? `${oneLinkUrl}` : this.getDeepLinkUrl();
      }
    }

    // console.log('rd ',deepLinkUrl);
    // const roadBlock = properties.getProperty("roadBlock");
    const imageBaseUrl = properties.getProperty('imageBaseUrl');
    const catPath = storageAvailable('localStorage') ? localStorage.getItem('categoryClicked') : '';
    // const imgsrc = !(catPath!='' && catPath!=null) ? `${imageBaseUrl}/static/img/newuser-variant1.jpg` : `${asseturl}/static/img/returninguser.jpg`;
    let imgsrc = !(catPath != '' && catPath != null) ? newUserImageUrl : returningUserImageUrl;
    imgsrc = imgsrc || `${imageBaseUrl}/static/img/newuser-variant1.jpg`;
    const roadblockclosed = storageAvailable('localStorage')
      ? localStorage.getItem('roadblockclosed')
      : true;
    let cookierb = readCookie('roadBlockCookie');
    let rb = window.sessionStorage ? window.sessionStorage.getItem('rb') : false;

    // let pageType = window.pageType
    // let deepLinkUrl;
    // if (navigator.userAgent.toUpperCase().indexOf("IPAD") > -1 || navigator.userAgent.toUpperCase().indexOf("IPHONE") > -1) {
    //   deepLinkUrl = `https://itunes.apple.com/in/app/ajio-online-shopping-app/id1113425372?rutm_campaign=${pageType}&utm_source=App_Install_Popup&utm_medium=App_Install_Popup`;
    // }
    //  else if (navigator.userAgent.toUpperCase().indexOf("ANDROID") > -1) {
    //    deepLinkUrl = `https://play.google.com/store/apps/details?id=com.ril.ajio&referrer=utm_source%3DApp_Install_Popup%26utm_medium%3DApp_Install_Popup%26utm_campaign%3D${pageType}`;
    //  }
    // else{
    //   deepLinkUrl = "#";
    // }
    return null;

    return this.state.popupOpen && !rb && !roadblockclosed && visible ? (
      <div className="popup-overlay">
        <div className="popup-roadblock" ref="popup-roadblock">
          <a
            target="_blank"
            href={deepLinkUrl}
            onClick={this.hideRoadblock.bind(this)}
            data-ga-event-category="Page Interaction"
            data-ga-event-label="Install"
            data-ga-event-action="App_Install"
          >
            <img src={imgsrc} width="100%" onError={this.onImageLoadError} alt='New user offer banner'/>
          </a>
          <span
            data-ga-event-category="Page Interaction"
            data-ga-event-label="Close"
            data-ga-event-action="App_Install"
            onClick={this.togglepopup.bind(this)}
            className="movetotop ic-close-quickview"
          />
        </div>
      </div>
    ) : null;
  }
}
function mapStateToProps({ roadblock: roadblockwcms }) {
  return {
    roadblockwcms
  };
}
export default connect(mapStateToProps, null)(PopupRoadblock);
